import React, { useRef } from 'react';
import logo from './assets/images/logo.png';
import './assets/theme.css'
import './App.css';
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css';
import { ConfirmDialog } from 'primereact/confirmdialog'; // For <ConfirmDialog /> component
import { Menu } from 'primereact/menu';
import { Outlet, createHashRouter, RouterProvider, useLocation, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ResearchPage from './pages/ResearchPage';
import NotesPage from './pages/NotesPage';
import TeachingPage from './pages/TeachingPage';
import LemniscatesPage from './pages/LemniscatesPage';
import { MenuItem } from 'primereact/menuitem';
import PhotoPage from './pages/PhotoPage';

const router = createHashRouter([
	{
		path: "/",
		element: <Layout/>,
		children: [
			{
				// index: true,
				path: "/",
				id: 'Home',
				element: <HomePage/>,
			},
			{
				// index: true,
				id: 'Research',
				path: "/research",
				element: <ResearchPage/>,
			},
			{
				// index: true,
				id: 'Notes',
				path: "/notes",
				element: <NotesPage/>,
			},	
			{
				// index: true,
				id: 'Teaching',
				path: "/teaching",
				element: <TeachingPage/>,
			},	
			{
				// index: true,
				id: '-Leminscates',
				path: "/lemniscates",
				element: <LemniscatesPage/>,
			},	
			{
				// index: true,
				id: '-Photo',
				path: "/photo",
				element: <PhotoPage/>,
			},		
		],
	},
  ],
//   {
//     basename: '/~tamiozzo/',
//   }
);

function App() {
	return (
		<div className="app">
			<RouterProvider router={router}/>
			<ConfirmDialog />
		</div>
	);
}

function Layout() 
{
	const  location = useLocation();
	const menuRight = useRef<Menu>(null);
	function toggleMenu(event: React.SyntheticEvent<Element, Event>)
	{
		menuRight.current?.toggle(event);
	}
	const items:MenuItem[] = [];
	for (const r of router.routes[0].children!) {
		if ( r.id.charAt(0) !== '-' )
		{
			items.push({
				template: () => {
					return (
						<div className='nav-link' key={r.id} style={{height: '3rem'}}>
							<Link to={r.path!} 
								style={{padding:'8px 6px', width: '100%'}}
								onClick={(event) => menuRight.current?.hide(event)}>{r.id}</Link>
						</div>
					)
			}
		})
		}
	}
	return (
		<>
			<div className="app-header">
				<div className="app-header-left">
					<div className='flex flex-column justify-content-center'>
						<img src={logo} className="app-logo" alt="logo" />
					</div>
					{/* <button id="menu" class="btn-nav"><span class="fas fa-bars"></span></button> */}
				</div>
				<div className="app-header-center">
					<span>Matteo Tamiozzo</span>
				</div>
				<div className="app-header-right" id='app-header-right'>
					{router.routes[0].children!.map(
						(r) => {
						if ( r.id?.charAt(0) === '-' )
							return null;
						else
						{
							const menuClass = `nav-link ${location.pathname===r.path ? 'active' : ''}`;
							return (
								<div className={menuClass} key={r.id}>
									<Link to={r.path!} id={r.id}>{r.id}</Link>
								</div>);
							}
						}
					)}
				</div>
				<i className="pi pi-align-justify app-header-menu" onClick={toggleMenu}></i>
				<Menu model={items} popup ref={menuRight} id="popup_menu_right" popupAlignment="right" 
				 pt={{
					root: { style: {backgroundColor: 'var(--global-color-4)', border: '1px solid'} },
				}}/>
			</div>
			<div className='main_content'>
				<Outlet />
			</div>
		</>
	);
}
export default App;

